import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommentsRequest, CommentsResponse } from "../interfaces/comments-establishment.interface";
import { environment } from "../../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CommentsEstablishmentService {
  private apiUrl = environment.apiUrl
  constructor(private http: HttpClient) {

  }


  loadComments(comments: CommentsRequest): Observable<CommentsResponse> {
    return this.http.post<CommentsResponse>(this.apiUrl + '/comments', comments);
  }
}
